<script lang="ts" context="module">
  import type { ComponentType } from 'svelte';

  export type LazyComponentModule<Component extends ComponentType> = {
    default: Component;
  };

  export type LazyComponent<Component extends ComponentType> = () => Promise<LazyComponentModule<Component>>;
</script>

<script lang="ts">
  import { onMount } from 'svelte';

  type Component = $$Generic<ComponentType>;

  export let component: LazyComponent<Component>;
  export let delayMs = null;

  let loadedComponent: ComponentType | null = null;
  let timeout: number;
  let showFallback = !delayMs;

  onMount(() => {
    if (delayMs) {
      timeout = window.setTimeout(() => {
        showFallback = true;
      }, delayMs);
    }

    (async () => {
      const module = await component();
      loadedComponent = module.default;
    })();

    return () => clearTimeout(timeout);
  });

  let props: object;
  $: {
    ({ delayMs, component, ...props } = $$props);
  }
</script>

{#if loadedComponent}
  <svelte:component this={loadedComponent} {...props} />
{:else if showFallback}
  <slot />
{/if}
